angular
    .module('webcomm')
    .controller('ChannelContextController', [
        '$scope', 
        '$log', 
        'endpointModel',
        'userService',
    function ($scope, $log, endpointModel, userService) {
        $log.debug('Loading ChannelContextController');

        function setUserCount() {
            $scope.userCount = userService.userCount;
        }

        function setEndpointsAndUserCount(channelEndpoints) {
            $scope.endpoints = channelEndpoints;
            setUserCount();
        }

        $scope.status = {};
        $scope.openFullscreenMap = function() {
            $scope.$emit('map.openFullscreenMap');
        };

        $scope.userCount = 0;

        $scope.endpointsEnabled = true;
        $scope.maxEndpointsOnChannel = 9999;

        var unbindUsersDisabledOnChannel = $scope.$on('endpointModel.endpointsDisabledOnChannel', function(e, channelId, max) {
            if(channelId === $scope.channel.id) {
                $scope.endpointsEnabled = false;
                $scope.maxEndpointsOnChannel = max;
            }
        });

        var unbindUsersEnabledOnChannel = $scope.$on('endpointModel.endpointsEnabledOnChannel', function(e, channelId) {
            if(channelId === $scope.channel.id) {
                $scope.endpointsEnabled = true;
            }
        });

        var unbindUsersLoaded = $scope.$on('userService.usersLoaded', function(e, users) {
            setUserCount();
        });

        var unbindEndpointsLoaded = $scope.$on('endpointModel.endpointsLoaded', function (e, channelEndpoints) {
            setEndpointsAndUserCount(channelEndpoints);
        });

        var unbindPresenceUpdated = $scope.$on('endpointModel.presenceUpdated', function(event, channelEndpoints) {
            setEndpointsAndUserCount(channelEndpoints);
        });

        $scope.$on('$destroy', function () {
            unbindUsersEnabledOnChannel();
            unbindUsersDisabledOnChannel();
            unbindEndpointsLoaded();
            unbindPresenceUpdated();
            unbindUsersLoaded();

            $log.debug('ChannelContextController destroyed');
        });
    }]);